export default __webpack_public_path__ + "static/media/logo.8de76d0a.svg";